export const tableId = 'CorporateActionsTable';
